/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ServiceLevel = {
    Expedited: 'EXPEDITED',
    NextDay: 'NEXT_DAY',
    Standard: 'STANDARD'
} as const;
export type ServiceLevel = typeof ServiceLevel[keyof typeof ServiceLevel];

